<router-outlet></router-outlet>

<ngx-spinner type="ball-circus" name="tpSpinner" template="<img width='500px' src='assets/spinner/tp-spinner.gif'/>"></ngx-spinner>